import { createFileRoute } from '@tanstack/react-router';
import { ForbiddenPage } from '@/pages/errors/ui/ForbiddenPage';

/**
 * 403 Forbidden ルート定義
 *
 * App層の責務:
 * - URLパス `/403` を ForbiddenPage にマッピング
 * - アクセス権限エラー時の表示
 * - TanStack Router のファイルベースルーティング
 */
export const Route = createFileRoute('/403')({
  component: ForbiddenPage,
});
